define('modules/util/buttons/buttons_view',[
  'backbone',
  'jquery',
  '_',

  'text!./buttons_item_template.html'
], function (Backbone, $, _,
             item_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      this.render();
    },
    subViews: [],
    item_template: _.template(item_template),
    tagName: 'ul',
    className: 'buttons',

    render: function () {
      var items = [];
      this.items.forEach(function (item) {
        var $item = $(this.item_template());
        $item.append(item.$el);
        items.push($item);
      }, this);
      this.subViews.push(items);
      this.$el.html(items);
      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }

  });
  return View;
});

